"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.County = void 0;
var County;
exports.County = County;

(function (County) {
  County["Oslo"] = "KVE:TopographicPlace:03";
  County["Rogaland"] = "KVE:TopographicPlace:11";
  County["MoreOgRomsdal"] = "KVE:TopographicPlace:15";
  County["Nordland"] = "KVE:TopographicPlace:18";
  County["Svalbard"] = "KVE:TopographicPlace:21";
  County["JanMayen"] = "KVE:TopographicPlace:22";
  County["Viken"] = "KVE:TopographicPlace:30";
  County["Innlandet"] = "KVE:TopographicPlace:34";
  County["VestfoldOgTelemark"] = "KVE:TopographicPlace:38";
  County["Agder"] = "KVE:TopographicPlace:42";
  County["Vestland"] = "KVE:TopographicPlace:46";
  County["Trondelag"] = "KVE:TopographicPlace:50";
  County["TromsOgFinnmark"] = "KVE:TopographicPlace:54";
  County["StockholmsLan"] = "LAN:TopographicPlace:01";
  County["UppsalaLan"] = "LAN:TopographicPlace:03";
  County["SodermanlandsLan"] = "LAN:TopographicPlace:04";
  County["OstergotlandsLan"] = "LAN:TopographicPlace:05";
  County["JonkopingsLan"] = "LAN:TopographicPlace:06";
  County["KronobergsLan"] = "LAN:TopographicPlace:07";
  County["KalmarLan"] = "LAN:TopographicPlace:08";
  County["GotlandsLan"] = "LAN:TopographicPlace:09";
  County["BlekingeLan"] = "LAN:TopographicPlace:10";
  County["SkaneLan"] = "LAN:TopographicPlace:12";
  County["HallandsLan"] = "LAN:TopographicPlace:13";
  County["VastraGotalandsLan"] = "LAN:TopographicPlace:14";
  County["VarmlandsLan"] = "LAN:TopographicPlace:17";
  County["OrebroLan"] = "LAN:TopographicPlace:18";
  County["VastmanlandsLan"] = "LAN:TopographicPlace:19";
  County["DalarnasLan"] = "LAN:TopographicPlace:20";
  County["GavleborgsLan"] = "LAN:TopographicPlace:21";
  County["VasternorrlandsLan"] = "LAN:TopographicPlace:22";
  County["JamtlandsLan"] = "LAN:TopographicPlace:23";
  County["VasterbottensLan"] = "LAN:TopographicPlace:24";
  County["NorrbottensLan"] = "LAN:TopographicPlace:25";
})(County || (exports.County = County = {}));